import React, { FC, ChangeEvent } from 'react';
import { useController, UseControllerProps, useFormContext } from 'react-hook-form';
import styles from '../../experience.module.scss';
import { ExperienceType, Experience } from '@domain/constant/profile/ExperienceType';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const getActivityTypeDescription = (activityType?: ExperienceType) => {
  switch (activityType) {
    case Experience.INTERNAL:
      return '활동명 및 어떤 경험을 했는지 간단히 입력해주세요.';
    case Experience.EXTERNAL:
      return '활동명 및 어떤 경험을 했는지 간단히 입력해주세요.';
    case Experience.EDUCATION:
      return '이수하신 교육명 및 과정에 대해 간단히 입력해주세요.';
    case Experience.VOLUNTEER:
      return '봉사명 및 어떤 활동을 했는지 간단히 입력해주세요.';
    case Experience.CLUB:
      return '동아리명 및 어떤 활동을 했는지 간단히 입력해주세요.';
    default:
      return '내용을 입력해주세요';
  }
};

type IActivityDescriptionProps = Omit<UseControllerProps, 'name'> & {
  prefixName: string;
};

const maxLength = 60;

const ActivityDescription: FC<IActivityDescriptionProps> = ({ prefixName, ...props }) => {
  const { watch } = useFormContext();

  const name = `${prefixName}.description`;
  const { field } = useController({ name, ...props });

  const length = field.value?.length ?? 0;

  const activityType = watch(`${prefixName}.tag`);
  const placeholder = getActivityTypeDescription(activityType?.value);

  //한글 입력시 maxLength 초과되는 이슈로 인해서 onChange 이벤트 추가
  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > maxLength) {
      return;
    }

    field.onChange(e.target.value);
  };

  return (
    <div className={cx('activityWrap')}>
      <div className={cx('activityTitle')}>내용</div>

      <div className={cx('textareaWrap')}>
        <textarea {...field} placeholder={placeholder} maxLength={maxLength} rows={4} onChange={onChange} />
        <div className={cx('infoText')}>
          최대 글자수 : <span className={cx('value')}>{length}</span> / 60
        </div>
      </div>
    </div>
  );
};

export default ActivityDescription;
